<template>
  <svg
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    width="24"
    height="24"
    viewBox="0 0 32 32"
    :stroke="color"
  >
    <title>fullscreen</title>
    <path
      fill="none"
      stroke-linejoin="round"
      stroke-linecap="round"
      stroke-miterlimit="4"
      stroke-width="2.6667"
      :stroke="color"
      d="M11.353 6.706h-8.52v5.422"
    />
    <path
      fill="none"
      stroke-linejoin="round"
      stroke-linecap="round"
      stroke-miterlimit="4"
      stroke-width="2.6667"
      :stroke="color"
      d="M20.647 6.706h8.52v5.422"
    />
    <path
      fill="none"
      stroke-linejoin="round"
      stroke-linecap="round"
      stroke-miterlimit="4"
      stroke-width="2.6667"
      :stroke="color"
      d="M20.647 25.294h8.52v-5.422"
    />
    <path
      fill="none"
      stroke-linejoin="round"
      stroke-linecap="round"
      stroke-miterlimit="4"
      stroke-width="2.6667"
      :stroke="color"
      d="M11.353 25.294h-8.52v-5.422"
    />
  </svg>
</template>

<script>
export default {
  name: 'SvgNewFullscreen',
  props: {
    color: {
      type: String,
      default () {
        return '#fff'
      }
    }
  }
}
</script>
